<template>
  <div id="app">
    <!-- Preloader Start -->
    <HeaderComp />
    <!-- Preloader Start -->

    <!-- Slider Area Start-->
    <div class="services-area">
      <div class="container">
        <!-- Section-tittle -->
        <div class="row d-flex justify-content-center">
          <div class="col-lg-8">
            <div class="section-tittle text-center mb-80">
              <h2>404 Page not found​</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Slider Area End-->

    <!-- ================ contact section start ================= -->
    <section class="contact-section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="contact-title"></h2>
          </div>
          <div class="col-lg-12">
            <router-link class="text-center" to="/">
              <h1>Return Home</h1>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- ================ contact section end ================= -->
    <FooterComp />
  </div>
</template>

<script>
import HeaderComp from "./sub/Header";
import FooterComp from "./sub/Footer";
export default {
  name: "App",
  data() {
    return {
      year: new Date().getFullYear(),
      name: "",
      email: "",
      message: "",
      subject: ""
    };
  },
  methods: {
    async sendMail() {
      let response = await this.$axios.post(
        "http://localhost:8085/api/frontend/sendmail",
        {
          message: this.message,
          name: this.name,
          email: this.email,
          subject: this.subject
        }
      );
      console.log(response.data);
    }
  },
  components: { HeaderComp, FooterComp }
};
</script>

<style>
</style>
